import {
  USER_SET_TOKEN_DATA,
  USER_SET_NEW_TOKEN_DATA,
  UNAUTHORIZED,
  AUCTIONS_FETCH_ACTIVE_TABS,
  USER_SIGN_AGREEMENT,
  GET_RECENTLY_ITEMS,
  GET_CONTACT_ITEMS
} from 'constants/action-types';

const PERMISSIONS = 'http://rapaport.com/permissions';

const initialState = {
  tokenData: null,
  isUnauthorized: false,
  permissions: [],
  activeTabs: {},
  isSignedAgreement: null,
  agreementLoader: false,
  recentlyViewsItems: [],
  contactItems: []
};

export const site = (state = initialState, action) => {
  switch (action.type) {
    case UNAUTHORIZED:
      return { ...state, isUnauthorized: true };
    case AUCTIONS_FETCH_ACTIVE_TABS.success:
      return { ...state, activeTabs: action.payload };
    case USER_SET_TOKEN_DATA:
      return {
        ...state,
        tokenData: action.payload,
        permissions:
          (action.payload &&
            action.payload.idTokenPayload[PERMISSIONS] &&
            action.payload.idTokenPayload[PERMISSIONS].diamondauction) ||
          [],
        isSignedAgreement: false
      };
    case USER_SET_NEW_TOKEN_DATA:
      return {
        ...state,
        tokenData: action.payload,
        permissions:
          (action.payload &&
            action.payload.idTokenPayload[PERMISSIONS] &&
            action.payload.idTokenPayload[PERMISSIONS].diamondauction) ||
          []
      };
    case USER_SIGN_AGREEMENT.pending:
      return {
        ...state,
        agreementLoader: true
      };
    case USER_SIGN_AGREEMENT.error:
      return {
        agreementLoader: false
      };
    case USER_SIGN_AGREEMENT.success:
      return {
        ...state,
        isSignedAgreement: true
      };
    case GET_RECENTLY_ITEMS.success:
      return {
        ...state,
        recentlyViewsItems: action.payload.jewelries
      };
    case GET_CONTACT_ITEMS.success:
      return {
        ...state,
        contactItems: action.payload.jewelries
      };
    default:
      return state;
  }
};
